import React from 'react';
import _ from 'lodash';
import useSWR from 'swr';
import { useAsioProvider } from 'frontastic';
import { useFormat } from '../../../../../helpers/hooks/useFormat';
import { CatalogsInfo } from '../../catalogs';
import Sidemenu from '../side-menu';

const CatalogsTastic = () => {
  const { formatMessage: formatAccountMessage } = useFormat({ name: 'account' });
  const contentTitle = formatAccountMessage({ id: 'account.catalog', defaultMessage: 'Corporate Catalogs' });
  const asioProvider = useAsioProvider();

  const { data: selection } = useSWR('selection', async () => {
    const result = await asioProvider.getProductSelection();
    return result?.productSelection ?? null;
  });

  return (
    <>
      <Sidemenu hash={'/my-account/catalog'} contentTitle={contentTitle}>
        <CatalogsInfo catalog={selection} />
      </Sidemenu>
    </>
  );
};

export default CatalogsTastic;
